import { defineMessages } from 'react-intl';

export const messages: {
	groupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	groupLabel: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.inline-filters.groupLabel',
		defaultMessage: 'Filter results',
		description:
			'Accessible name for the group of filter controls that sits at the end of the search filter row.',
	},
});
